// extracted by mini-css-extract-plugin
export var cardHeader = "_sq-0";
export var reorderHandle = "_sq-3";
export var titleArea = "_sq-1";
export var titleAreaWithHandle = "_sq-2";